import { produce } from "immer";
import * as tagsActions from "./tagsActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = {
  isFetching: false,
  isSubmitting: false,
  errorMessage: null,
  byId: {},
  allIds: [],
  openModalType: null,
  activeTagId: null,
  isOpenDeleteModal: false,
  modalErrorMessage: null,
  tags: []
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case tagsActions.FETCH_TAGS_SUCCESS: {
      draft.tags = action.payload;
      const contactIds = action.payload.map(message => message.id);
      const byId = action.payload.reduce((obj, message) => {
        obj[message.id] = {
          ...message
        };
        return obj;
      }, {});
      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      draft.allIds = deepmerge(draft.allIds, contactIds, {
        arrayMerge: combineMerge
      });

      draft.isFetching = false;
      break;
    }
    case tagsActions.FETCH_TAGS_PENDING: {
      draft.isFetching = true;
      draft.errorMessage = null;
      break;
    }
    case tagsActions.FETCH_TAGS_FAILED: {
      draft.isFetching = true;
      draft.errorMessage = action.payload;
      break;
    }

    case tagsActions.CREATE_TAG_PENDING: {
      draft.isSubmitting = true;
      break;
    }

    case tagsActions.OPEN_CREATE_MODAL: {
      const { id, status } = action.payload;
      draft.openModalType = status;
      draft.activeTagId = id;
      break;
    }
    case tagsActions.CLOSE_CREATE_MODAL: {
      draft.openModalType = null;
      draft.activeTagId = null;
      draft.modalErrorMessage = null;
      break;
    }

    case tagsActions.CREATE_TAG_SUCCESS: {
      draft.isSubmitting = false;
      draft.openModalType = null;
      draft.byId[action.payload.id] = action.payload;
      draft.allIds.push(action.payload.id);
      break;
    }
    case tagsActions.CREATE_TAG_FAILED: {
      draft.isSubmitting = false;
      draft.modalErrorMessage = action.payload;
      break;
    }
    case tagsActions.DELETE_TAG_SUCCESS: {
      draft.isSubmitting = false;
      draft.openModalType = null;
      draft.activeTagId = null;
      draft.allIds = draft.allIds.filter(item => item !== action.payload);

      break;
    }
    case tagsActions.DELETE_TAG_PENDING: {
      draft.isSubmitting = true;
      break;
    }
    case tagsActions.UPDATE_TAG_PENDING: {
      draft.isSubmitting = true;

      break;
    }
    case tagsActions.UPDATE_TAG_SUCCESS: {
      draft.isSubmitting = false;
      draft.openModalType = null;
      draft.byId[action.payload.id] = {
        ...draft.byId[action.payload.id],
        ...action.payload
      };
      break;
    }
    case tagsActions.UPDATE_TAG_FAILED: {
      draft.isSubmitting = false;
      draft.modalErrorMessage = action.payload;
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
